export default {
    baseUrl: process.env.REACT_APP_API_ENDPOINT,
    baseGatewayUrl: process.env.REACT_APP_GATEWAY_API_ENDPOINT,
    environment: process.env.NODE_ENV,
    socketUrl: process.env.REACT_APP_SOCKET_ENDPOINT,
    crmBaseUrl: process.env.REACT_APP_CRM_API_ENDPOINT,
    // baseUrl: "https://dev-api.lotusdew.in/",
    // baseGatewayUrl: "https://dev-gateway.lotusdew.in/",
    // environment: "dev", 
}